import React from "react";
import { formatDateInJobStatsLog } from "../../../../utils";
import MessageMediaGrid from "../../messageMediaGrid/MessageMediaGrid";

const Left = ({ message }) => {
    const { hasFiles, imageGridStyle, imageStyle } = MessageMediaGrid(message);

    return (
        <div className="row justify-content-start mb-4">
            <div
                className="d-flex align-items-start"
                style={{ width: "100%" }}
            >
                {/* 👤 User Icon */}
                <div
                    style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        backgroundColor: "#eee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 10,
                        flexShrink: 0,
                    }}
                >
                    <i className="material-symbols-rounded">
                        person
                    </i>
                </div>

                {/* 💬 Message */}
                <div
                    className={hasFiles ? "col-5" : "col-auto"}
                    style={{ width: "90%" }}
                >
                    <div className="card">
                        <div
                            className={`card-body ${
                                hasFiles ? "p-2" : "py-2 px-3"
                            }`}
                        >
                            {/* Sender */}
                            <p className="text-sm text-bold mb-1">
                                {message.message_sender?.user_name} (
                                {message.message_sender?.user_type})
                            </p>

                            {/* Message */}
                            <p className="text-sm mt-0 mb-0">
                                {message.message_content?.text}
                            </p>

                            {/* Images */}
                            {hasFiles && (
                                <div style={imageGridStyle}>
                                    {message.message_content.files.map(
                                        (image, index) => (
                                            <a
                                                key={index}
                                                href={image.path}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    src={image.path}
                                                    alt="chat-img"
                                                    style={imageStyle}
                                                />
                                            </a>
                                        )
                                    )}
                                </div>
                            )}

                            {/* Time */}
                            <div className="d-flex align-items-center text-sm opacity-6 mt-1">
                                <i className="material-symbols-rounded">
                                    outbox
                                </i>
                                <small className="text-bold ms-1">
                                    {formatDateInJobStatsLog(
                                        message?.message_time
                                    )}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Left;